import type { CSSObject } from '@ant-design/cssinjs'
import { Keyframes } from '@ant-design/cssinjs'

// ── 荧光青色系 ──
export const cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00f0ff',
  600: '#00c8d6',
  700: '#00a0ab',
  800: '#007880',
  900: '#005055',
}

// ── 深空灰背景色系 ──
export const space = {
  900: '#0b1120',
  800: '#0f1729',
  700: '#131d35',
  600: '#1a2540',
  500: '#1e2d4a',
  400: '#243654',
  300: '#2a3f5e',
}

// ── Neon 发光阴影 ──
export const neonSm = `0 0 6px ${cyan[500]}40, 0 0 2px ${cyan[500]}80`
export const neonMd = `0 0 12px ${cyan[500]}50, 0 0 4px ${cyan[500]}90`
export const neonLg = `0 0 20px ${cyan[500]}60, 0 0 6px ${cyan[500]}a0`

// ── 扫描线动画 ──
export const scanlineKeyframes = new Keyframes('cyber-scanline', {
  '0%': { backgroundPosition: '0 0' },
  '100%': { backgroundPosition: '0 100%' },
})

// ── 边框呼吸动画 ──
export const pulseKeyframes = new Keyframes('cyber-pulse', {
  '0%, 100%': { boxShadow: `0 0 4px ${cyan[500]}30, inset 0 0 4px ${cyan[500]}10` },
  '50%': { boxShadow: `0 0 10px ${cyan[500]}50, inset 0 0 6px ${cyan[500]}20` },
})

// ── shimmer 扫光动画 ──
export const shimmerKeyframes = new Keyframes('cyber-shimmer', {
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
})

// ── 通用过渡 ──
export const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
export const transitionFast = 'all 0.12s cubic-bezier(0.4, 0, 0.2, 1)'

// ── 磨砂玻璃效果 ──
export const getGlassStyle = (intensity: 'light' | 'heavy' = 'light'): CSSObject => ({
  backdropFilter: intensity === 'heavy' ? 'blur(20px) saturate(180%)' : 'blur(12px) saturate(160%)',
  WebkitBackdropFilter: intensity === 'heavy' ? 'blur(20px) saturate(180%)' : 'blur(12px) saturate(160%)',
  background: intensity === 'heavy'
    ? `rgba(11, 17, 32, 0.82)`
    : `rgba(15, 23, 41, 0.72)`,
})

// ── Neon 边框 (1px 发光) ──
export const getNeonBorder = (): CSSObject => ({
  border: `1px solid ${cyan[500]}25`,
  boxShadow: `inset 0 0 1px ${cyan[500]}15`,
})

// ── 切角装饰 (clip-path) ──
export const getClipCorner = (size: number = 8): CSSObject => ({
  clipPath: `polygon(${size}px 0, 100% 0, 100% calc(100% - ${size}px), calc(100% - ${size}px) 100%, 0 100%, 0 ${size}px)`,
})
